import axios from "axios";
import { DataGrid, DropDownBox } from "devextreme-react";
import {
  Column,
  FilterRow,
  HeaderFilter,
  Scrolling,
  Selection,
} from "devextreme-react/data-grid";
import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUniversityList } from "./Redux/universityList";

export default function UniversityDropDownBox(props) {
  const { universityDropDownBoxRef, educationGridRef } = props;

  const [univId, setUnivId] = useState(
    educationGridRef.current.instance.getSelectedRowsData().length == 0
      ? null
      : Array.of(
          educationGridRef.current.instance.getSelectedRowsData()[0].univId
        )
  );
  const [isGridBoxOpend, setIsGridBoxOpened] = useState(false);
  const [dataSource, setDataSource] = useState(null);

  const universityList = useSelector((state) => state.universityList);

  // const universityDropDownBoxRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(async () => {
    if (universityList.universityList.length == 0) {
      try {
        const result = await axios.get(
          `${process.env.REACT_APP_BECCO_API_URL}/api/cv/education/univ`
        );

        // setDataSource(result.data);
        dispatch(updateUniversityList(result.data));

        setDataSource(result.data);
      } catch (error) {
        console.error(error);
      }
    } else {
      setDataSource(universityList.universityList);
    }
  }, []);

  const onSelectionChanged = (e) => {
    if (e.selectedRowKeys.length > 0) {
      setUnivId(e.selectedRowKeys);
    }

    setIsGridBoxOpened(false);
  };

  const contentRender = () => {
    return (
      <DataGrid
        keyExpr={"univId"}
        dataSource={dataSource}
        hoverStateEnabled={true}
        selectedRowKeys={typeof univId == "string" ? Array.of(univId) : univId}
        // selectedRowKeys={univId}
        onSelectionChanged={onSelectionChanged}
        height={"100%"}
        showBorders={true}
        showColumnLines={true}
      >
        <Selection mode={"single"} />
        <Scrolling mode={"virtual"} showScrollbar="always" />

        <FilterRow visible={"true"} />
        <HeaderFilter visible={"true"} />

        <Column dataField={"schoolName"} caption="Name" width={150} />
        <Column dataField={"adres"} caption="Address" />
      </DataGrid>
    );
  };

  const onValueChanged = (e) => {
    if (e.value) {
      universityDropDownBoxRef.current.instance.option(
        "validationStatus",
        "valid"
      );
    }
  };

  const onOptionChanged = (e) => {
    if (e.name === "opened") {
      setIsGridBoxOpened(e.value);
    }
  };

  const displayExpr = (item) => {
    // return item.schoolName;
    return `test`;
  };

  return (
    <DropDownBox
      ref={universityDropDownBoxRef}
      name="univId"
      value={univId}
      opened={isGridBoxOpend}
      dataSource={dataSource}
      valueExpr={"univId"}
      displayExpr={"schoolName"}
      //   displayExpr={displayExpr}
      deferRendering={false}
      placeholder="Select a value..."
      contentRender={contentRender}
      onValueChanged={onValueChanged}
      onOptionChanged={onOptionChanged}
    />
  );
}
